import { Link } from "react-router-dom";
import LegalLayout from "@/components/LegalLayout";
import Seo from "@/components/Seo";
import { blogPosts } from "@/data/blogPosts";
import { SITE_URL, breadcrumbSchema } from "@/lib/schema";

const BLOG_DESCRIPTION =
  "Tipps und Hintergründe zu Automatisierung für Handwerksbetriebe, Praxen und Immobilienverwalter in der Rhein-Neckar-Region.";

export const BlogIndex = () => {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Blog",
      name: "Kurpfalz Automation Blog",
      url: `${SITE_URL}/blog`,
      blogPost: blogPosts.map((post) => ({
        "@type": "BlogPosting",
        headline: post.title,
        datePublished: post.date,
        url: `${SITE_URL}/blog/${post.slug}`,
      })),
    },
    breadcrumbSchema([
      { name: "Startseite", path: "/" },
      { name: "Blog", path: "/blog" },
    ]),
  ];

  return (
    <LegalLayout title="Blog" updated={null}>
      <Seo title="Blog – Kurpfalz Automation" description={BLOG_DESCRIPTION} path="/blog" jsonLd={jsonLd} />
      <div className="space-y-8">
        {blogPosts.map((post) => (
          <article key={post.slug} className="border-b border-slate-200 pb-8 last:border-0">
            <h2 className="font-bold text-2xl text-[#16273F]">
              <Link to={`/blog/${post.slug}`} className="hover:text-[#9A8420] transition-colors">
                {post.title}
              </Link>
            </h2>
            <p className="mt-2 text-sm text-slate-500">{post.date}</p>
            <p className="mt-3">{post.excerpt}</p>
            <Link
              to={`/blog/${post.slug}`}
              className="mt-3 inline-block text-sm font-semibold text-[#9A8420] hover:text-[#7d6b1a]"
            >
              Weiterlesen →
            </Link>
          </article>
        ))}
      </div>
    </LegalLayout>
  );
};

export default BlogIndex;
